import { render, staticRenderFns } from "./tx-fw-preference.vue?vue&type=template&id=3329b13a&scoped=true&"
import script from "./tx-fw-preference.ts?vue&type=script&lang=ts&"
export * from "./tx-fw-preference.ts?vue&type=script&lang=ts&"
import style0 from "./tx-fw-preference.scss?vue&type=style&index=0&id=3329b13a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3329b13a",
  null
  
)

export default component.exports